import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { RecipientRequestVerificationType } from '@/types/vendorVaultTypes';

export const getRecipientRequestVerificationApi = (
  id: string
): Promise<ApiResponseType<RecipientRequestVerificationType>> =>
  authApiService.GET(`/vendor-vault/requests/${id}/verification/`);
